var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tolRef)?_c('div',{staticClass:"tol-ref"},[_c('span',{staticClass:"tol-ref__key"},[_vm._v("Ref")]),_c('span',{staticClass:"tol-ref__value"},[_vm._v(_vm._s(_vm.tolRef))]),_c('span',{staticClass:"tol-ref__action",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('view')}}},[_vm._v("View ↗")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }